import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./form.css";
import { useDispatch } from "react-redux";
import { loginUser } from "../../redux/apiCalls/authApiCall";
import { MdMarkEmailUnread } from "react-icons/md";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import docLog from "../../images/doctors/doccartton.jpg";

const Login = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visiblePassword, setVisiblePassword] = useState(false);

  const loginSubmitHandler = (e) => {
    e.preventDefault();
    if (email.trim() === "") {
      return toast.error("يجب ادخال الاميل");
    }
    if (password.trim() === "") {
      return toast.error("يجب ادخال كلمة المرور");
    }
    dispatch(loginUser({ email, password }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="page-style">
        <div className="form-wrapper ms-3">
          <img src={docLog} alt="doc" />
          <h4 className="form-title-log">دخول</h4>
          <form onSubmit={loginSubmitHandler} className="form">
            <div className="form-input">
              <input
                type="email"
                placeholder="الاميل"
                className="form-input"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <MdMarkEmailUnread className="register-icon" />
            </div>

            <div className="form-input">
              <input
                type={visiblePassword ? "text" : "password"}
                placeholder="كلمة السر"
                className="form-input"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                onClick={() => setVisiblePassword(!visiblePassword)}
                className="icons-wrapper-register"
              >
                {visiblePassword ? (
                  <BsEyeFill className="register-icon" />
                ) : (
                  <BsEyeSlashFill className="register-icon" />
                )}
              </div>
            </div>
            <button type="submit">دخول</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
